import React from "react";
import { Star } from "lucide-react";

import { cn } from "lib/utils";

interface StarRatingProps {
    value: number;
    max?: number;
    className?: string;
    starClassName?: string;
    emptyStarClassName?: string;
    filledStarClassName?: string;
}

const StarRating: React.FC<StarRatingProps> = ({
    value,
    max = 5,
    className,
    starClassName,
    emptyStarClassName,
    filledStarClassName,
}) => {
    const clamped = Math.max(0, Math.min(value, max));
    const fillPercent = (clamped / max) * 100;

    const starClasses = cn("h-5 w-5 shrink-0", starClassName);

    const stars = (fillClassName: string) =>
        Array.from({ length: max }).map((_, i) => (
            <Star key={i} aria-hidden className={cn(starClasses, fillClassName)} />
        ));

    return (
        <div
            role="img"
            aria-label={`Note ${clamped} sur ${max}`}
            className={cn("relative inline-flex", className)}
        >
            <div className="flex">{stars(cn("fill-muted stroke-muted-foreground/10", emptyStarClassName))}</div>
            <div
                aria-hidden
                className="absolute inset-y-0 left-0 overflow-hidden"
                style={{ width: `${fillPercent}%` }}
            >
                <div className="flex">{stars(cn("fill-amber-400 stroke-amber-400", filledStarClassName))}</div>
            </div>
        </div>
    );
};

export default StarRating;
